module.exports = __webpack_public_path__ + "img/home.223a4e99.svg";